module.exports = __webpack_public_path__ + "img/pic_162924_3.bf361b15.jpg";